import { PagingService } from './../../Services/PagingService';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../Services/notification.service';
import { PagingModel } from '../../Models/PagingModel';
import { Router } from '@angular/router';
import { BaseComponent } from '../base/base.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent extends BaseComponent implements OnInit {
  componentModel: PagingModel;
  userId: number;
  notifications: any[];
  isnotreadcount: number;
  constructor(public service: NotificationService, public route: Router, public paging: PagingService) {
    super(route, service, paging, '');
    // this.userId = +this.login.token.userId;
    this.componentModel = new PagingModel();
  }

  ngOnInit() {
    this.service.getByUserId(this.userId).subscribe((data) => {
      this.notifications = data['notifications'];
      this.isnotreadcount = data['notReadCount'];
    });
  }
}
